import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { isSuperAdmin, isCompanyAdmin } from "../../helpers/helpers";
import {filterUser, getCustomUsers, getLoggedUser, getUsers, getUsersError} from "../../store/actions/usersActions";
import {getNotifications} from "../../store/actions/notificationsActions";
import {getAllFields, getFields} from "../../store/actions/fieldsActions";
import {getSensors} from "../../store/actions/sensorsActions";
import './Header.scss';

import UserDropDown from "../UserDropDown";
import LanguageSelector from "../LanguageSelector";
import ErrorModal from "../_common/ErrorModal";
import ExternalModal from "../_common/ExternalModal";
import ChangeTimePeriodModal from "../ChangeTimePeriodModal";

const selector = state => {
    const { language, users, sensors } = state;
    return {
        t: language.translator,
        users: users.customUsers,
        filteredUser: users.filtered,
        sensorsFilters: sensors.filters,
        loggedUser: users.loggedUser,
        error: users.error
    }
};

const Header = () => {
    const { t, users, loggedUser, error, sensorsFilters, filteredUser } = useSelector(selector);
    const history = useHistory();
    const dispatch = useDispatch();
    const [searchInput, setSearchInput] = useState('');
    const [showSearchOptions, setShowSearchOptions] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [timeReportingModal, setTimeReportingModal] = useState(false)

    useEffect(() => {
        dispatch(getLoggedUser());
        // if(isSuperAdmin() || isCompanyAdmin()) {
        //     dispatch(getUsers());
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const searchOnTyping = (text) => {
        if(text.length > 2) {
            dispatch(getCustomUsers(text))
            setSearchInput(text);
            setShowSearchOptions(true)

            // setTimeout(() => setShowSearchOptions(false), 3000)
        }

    };

    const toggleTimeConfiguration = () => {
        setTimeReportingModal(!timeReportingModal)
    }

    return (
        <header className='mainHeader'>

            <div className='mainHeader--left'>
                <LanguageSelector />
                {(isSuperAdmin() && history.location.pathname === '/sensor') && (
                    <div className='measurementsButtonHolder'>
                        <button
                            className='measurementsAddButton measurementsAddButton--measurementsTime'
                            onClick={e => {
                                e.preventDefault();
                                toggleTimeConfiguration();
                            }}
                            // disabled={disableButtons}
                        >
                            {t.gettext('Configure time reporting')}
                        </button>
                    </div>
                )}
            </div>

            <div className='mainHeader--right'>
                {(isSuperAdmin() || isCompanyAdmin()) && (
                    history.location.pathname === '/'
                    || history.location.pathname === '/sensor'
                    || history.location.pathname === '/sensor_groups'
                ) &&
                    <>
                        {Object.keys(filteredUser).length === 0 && filteredUser.constructor === Object
                            ?
                            <div className='searchBoxWrapper'>
                                <input
                                    className='userSearchInput'
                                    type='text'
                                    placeholder={t.gettext('Search user')}
                                    onKeyUp={(e) => searchOnTyping(e.target.value)}
                                    // onChange={e => {
                                    //     setSearchInput(e.target.value);
                                    //     setShowSearchOptions(true)
                                    // }}
                                />
                                <span className='material-icons userSearchIcon'>
                                    search
                                </span>
                                {/*{!!users.filter(user => user.fullName && user.fullName.toUpperCase().includes(searchInput.toUpperCase())).length && showSearchOptions && !!searchInput.length &&*/}
                                {showSearchOptions && !!searchInput.length &&
                                    <>
                                        <div onClick={() => setShowSearchOptions(false)} className="fullBg">
                                        </div>
                                        <ul className='searchOptionsList'>
                                            {/*{users.filter(user => user.fullName && user.fullName.toUpperCase().includes(searchInput.toUpperCase())).map(user => (*/}
                                            {users.map(user => (
                                                <li className='searchOption'
                                                    key={user.id}
                                                    onClick={() => {
                                                        setSelectedUser({name: user.fullName, id: user.id});
                                                        setShowSearchOptions(false);
                                                        dispatch(filterUser(user));
                                                        dispatch(getNotifications(user.id));
                                                        dispatch(getFields(user.id));
                                                        dispatch(getSensors(
                                                            1,
                                                            sensorsFilters.itemsPerPage ? sensorsFilters.itemsPerPage : 3,
                                                            sensorsFilters.active ? sensorsFilters.active : 'ALL',
                                                            user.id,
                                                            sensorsFilters.search ? sensorsFilters.search : ''
                                                        ));
                                                    }}
                                                >
                                                    {user.fullName + ' ' + user.email}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                }
                            </div>
                            :
                            <div className='searchBoxWrapper'>
                                <div className='userSearchInput'>
                                    {selectedUser.name}
                                </div>
                                <span
                                    className='material-icons userSearchIcon userClearIcon'
                                    onClick={() => {
                                        setSelectedUser({});
                                        setSearchInput('');
                                        dispatch(filterUser({}));
                                        dispatch(getNotifications());
                                        dispatch(getAllFields());
                                        dispatch(getSensors(
                                            1,
                                            sensorsFilters.itemsPerPage ? sensorsFilters.itemsPerPage : 3,
                                            sensorsFilters.active ? sensorsFilters.active : 'ALL',
                                            '',
                                            sensorsFilters.search ? sensorsFilters.search : ''
                                        ));
                                    }}
                                >
                                    cancel
                                </span>
                            </div>
                        }
                    </>
                }
                <UserDropDown user={loggedUser}/>
            </div>

            {error &&
                <ErrorModal
                    error={error}
                    closeMethod={() => dispatch(getUsersError(''))}
                />
            }

            {timeReportingModal &&
                <ExternalModal
                    messageModal
                >
                    <ChangeTimePeriodModal
                        globalConfiguration
                        closeMethod={toggleTimeConfiguration}
                    />
                </ExternalModal>
            }

        </header>
    );
};

export default Header;
